var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuExpandableClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.08,
    height: 9.814,
    viewBox: "0 0 16.08 9.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M-9351.2-41.944l6.258,6.278,6.285-6.278",
    transform: "translate(-9336.892 -33.898) rotate(180)",
    fill: "none",
    stroke: "#0082ca",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuExpandableClose);
export default __webpack_public_path__ + "static/media/mobile-menu-expandable-close.0338da21b3c8905bb853f643e5c4e442.svg";
export { ForwardRef as ReactComponent };